import siteContent from "@/data/siteContent.json";

/**
 * Read-only catalogue compatibility layer for the independently hosted site.
 * No browser requests to the retired Emergent backend or MongoDB.
 */
export const API = "";
const copy = (value) => JSON.parse(JSON.stringify(value));
const get = async (url, options = {}) => {
  const path = String(url).split("?")[0];
  const params = options.params || {};
  if (path === "/products") {
    let products = siteContent.products.filter((p) => p.is_active !== false);
    if (params.category_id) products = products.filter((p) => p.category_id === params.category_id);
    if (params.search) {
      const term = String(params.search).toLowerCase().trim();
      products = products.filter((p) => [p.name,p.description,...(p.highlights || [])].join(" ").toLowerCase().includes(term));
    }
    return { data: copy(products) };
  }
  if (path.startsWith("/products/")) {
    const id = decodeURIComponent(path.slice("/products/".length));
    const product = siteContent.products.find((p) => p.id === id);
    if (product) return { data: copy(product) };
  }
  if (path === "/categories") return { data: copy(siteContent.categories) };
  if (path === "/gallery") return { data: copy(params.category ? siteContent.gallery.filter((x) => x.category === params.category) : siteContent.gallery) };
  if (path === "/certifications") return { data: copy(siteContent.certifications) };
  if (path === "/brochures") return { data: copy(siteContent.brochures) };
  if (path === "/settings") return { data: copy(siteContent.settings) };
  if (path === "/blogs") return { data: copy(siteContent.blogs.filter((b) => !params.published_only || b.is_published !== false)) };
  if (path.startsWith("/blogs/")) {
    const blog = siteContent.blogs.find((b) => b.slug === decodeURIComponent(path.slice("/blogs/".length)));
    if (blog) return { data: copy(blog) };
  }
  throw new Error("This item is not available in the static catalogue.");
};
export const api = { get };
export function formatApiError(detail) { return typeof detail === "string" ? detail : "Please contact Forage by email."; }
